import styled from '@emotion/styled';

export const CollapsibleContainer = styled.div`
  width: 100%;
`;

export const CollapsibleSummaryContainer = styled.div`
  display: flex;
  height: 50px;
  width: 100%;
  background-color: white;
  border: 1px solid ${(props) => props?.theme?.colors.blue1[40]};
  border-radius: 8px;
  padding: 0 15px;
`;

export const CollapsibleTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  flex: 1;
`;

type CollapsibleDetailProps = {
  collapsed: boolean;
};

export const CollapsibleDetail = styled.div<CollapsibleDetailProps>`
  display: flex;
  flex-direction: row;
  max-height: ${(props) => (props.collapsed ? '2rem' : '100%')};
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  justify-content: space-between;
`;

export const DashedLineContainer = styled.div`
  display: flex;
  justify-content: center;
  width: ${(props) => props?.theme?.typography.large32};
  margin-right: ${(props) => props?.theme?.typography.large18};
  overflow: hidden;
`;

export const HidingContainer = styled.div`
  overflow: hidden;
  border-radius: 4px;
`;

export const FullDashContainer = styled.div`
  width: 4px;
  overflow: hidden;
  min-height: 10rem;
  max-height: 100%;
`;

type DetailContentProps = {
  collapsed: boolean;
};

export const DetailContent = styled.div<DetailContentProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  opacity: ${(props) => (props.collapsed ? '0%' : '100%')};
  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: ${(props) => props?.theme?.typography.large18} 0;
  pointer-events: ${(props) => (props.collapsed ? 'none' : 'auto')}; ;
`;
